import { Arr, RecordStore } from '@deqo/foundation';
import * as HelpVideos from '../../../@resources/help';
import { AppLocation } from '../../AppLocation';
import { resolve } from '../../Container';
import { MetricsHub } from '../../MetricsHub';
import { HelpTip } from './HelpTip';
import { HelpVideo } from './HelpVideo';

const mvk = (type: 'seen' | 'recommended' | 'ignored', video: HelpVideo) => `haug/${type}/${video.key}`;
const mtk = (tip: HelpTip) => `haugTip/${tip.key}/${tip.mount}/`;

const initialState = {
    activeTips: [] as HelpTip[],
    activeVideo: null as HelpVideo,
    libraryOpen: false,
    libraryFilter: '*',
    recommendedVideos: [] as HelpVideo[],
};

export class HelpController extends RecordStore(initialState) {

    @resolve(MetricsHub) private metrics!: MetricsHub;
    @resolve(AppLocation) private location!: AppLocation;

    public start() {
        this.refreshRecommendations();
        this.burden(
            // this.preferences.observe(this.realizeWidget),
            // this.session.observe(MyRoleInfo, this.realizeWidget),
        );
    }

    public openLibrary(libraryFilter?: string) {
        libraryFilter =
            libraryFilter ||
            (this.location.includes('board') ? 'editor' : 'dashboard');

        this.updateState({ libraryOpen: true, libraryFilter });
        // Dismiss tips on the videos mount
        for (const tip of this.activeTips) {
            if (tip.mount === 'videos') {
                this.dismissTip(tip.key);
            }
        }
    }

    public closeLibrary() {
        this.updateState({ libraryOpen: false });
    }

    public openVideo(video: HelpVideo) {
        this.dismissVideo();
        this.updateState({ activeVideo: video });
        this.metrics.inc(mvk('seen', video));
        this.closeLibrary();
        this.refreshRecommendations();
    }

    public dismissVideo() {
        this.updateState({ activeVideo: null });
    }

    public recommendVideo(video: HelpVideo): boolean {
        if (this.metrics.check(mvk('seen', video))) return false;
        if (this.metrics.check(mvk('ignored', video))) return false;
        this.metrics.inc(mvk('recommended', video));
        this.updateState({
            recommendedVideos: Arr.unique([...this.recommendedVideos, video])
        });
        return true;
    }

    public ignoreVideo(video: HelpVideo): void {
        this.metrics.inc(mvk('ignored', video));
        this.refreshRecommendations();
    }

    public ignoreRecommendations() {
        for (const video of this.recommendedVideos) {
            this.metrics.inc(mvk('ignored', video));
        }
        this.refreshRecommendations();
    }

    public openTip(tip: HelpTip) {
        if (this.metrics.check(mtk(tip))) return;
        this.updateState(x => x.activeTips.push(tip));
        this.metrics.inc(mtk(tip));
    }

    public dismissTip(keyOrTip?: string | HelpTip) {
        const key = typeof keyOrTip === 'string' ? keyOrTip : keyOrTip?.key;
        this.updateState(x => {
            const i = !!key ? x.activeTips.findIndex(t => t.key === key) : 0;
            if (i < 0) return;
            x.activeTips.splice(0, 1);
        });
    }

    public toggleTip(tip: HelpTip, active: boolean) {
        if (active) {
            this.openTip(tip);
        }
        else {
            this.dismissTip(tip);
        }
    }

    private refreshRecommendations() {

        const rvs = Object.values(HelpVideos).filter(v => {
            const seen = this.metrics.check(mvk('seen', v));
            const recommend = this.metrics.check(mvk('recommended', v));
            const ignored = this.metrics.check(mvk('ignored', v));
            return !seen && !ignored && !!recommend;
        });

        this.updateState({ recommendedVideos: rvs });
    }
}
